module.exports = __webpack_public_path__ + "static/media/20210403_200720_277_IMG_0010.33b82d5d.jpg";